module.exports = __webpack_public_path__ + "img/delete-sentosa.a0e7b627.svg";